export const iconFontAwesomeGamingDiceFour = (
	<i className="fa-solid fa-dice-four"></i>
);
